<template>
  <div class="request">
    <steps v-if="stepCount" :step-count="stepCount" :current-step="currentStep" />
    <weui-group :title="`您需要发送验证申请，等待${ coach && coach.name }教练通过`" tips="为了便于教练辨认您的身份，建议填写你们之间的常用称呼。">
      <weui-cell>
        <input type="text" title="验证信息" v-model="message">
      </weui-cell>
    </weui-group>
    <weui-group>
      <weui-button-cell @click="submit">下一步</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import Steps from '@/components/share/Steps';
import { ROUTE_SHARE_QRCODE } from '@/router/names';
import { REQUEST_SHARE_BINDING } from '@/store/share/types';

const { mapActions } = createNamespacedHelpers('share');

export default {
    props: {
        hash: {
            type: String,
            required: true,
        },
        coach: {
            type: Object,
            default() {
                return {};
            },
        },
        stepCount: {
            type: Number,
            default: 0,
        },
        currentStep: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            message: '我是',
        };
    },
    methods: {
        ...mapActions({
            requestBinding: REQUEST_SHARE_BINDING,
        }),
        async submit() {
            await this.requestBinding({
                hash: this.hash,
                message: this.message,
            });
            this.$router.replace({
                name: ROUTE_SHARE_QRCODE,
                params: {
                    hash: this.hash,
                },
            });
        },
    },
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/share/Request.vue